import { Microproceso } from './tarea.model';
import { Tramite } from './tramite.model';
import { TipoControl } from './formulario-dinamico.model';
/**
 * modelo de la informacion global del sistema
 *
 * @export
 * @class GlobalInfo
 */
export class GlobalInfo {
  // Título global de la vista actual
 title: string;
 // Referencia del flujo actual con el que el usuario interactua
 flow: Tramite | Microproceso;
 // Define si el trámite esta sincronizado con la DB en automatización de procesos.
 tramiteIsSynchronized: boolean;
 // Cambios pendientes dentro de la app
 pendingChanges: {
  processAutomation: boolean
 };
 flowsHistory: Array<number>;
}

/**
 * Modelo de los campos dinamicos de las consultas de calendario y tramites
 *
 * @export
 * @class CampoDinamico
 */
export class CampoDinamico {
  id: number;
  nombre_parametro: string;
  orden: number;
  valor: any;
}

/**
 * Modelo de la consulta de los filtros de un reporte o un tramite
 *
 * @export
 * @class FiltroReporte
 */
export class Filtro {
  id?: number;
  nombre: string;
  parametros: ParametroFiltro[];
}

/**
 * Modelo complementario de los campos de filtros para la consulta de reporte o tramite
 *
 * @export
 * @class ParametroFiltro
 */
// export class ParametroFiltro {
//   id: number;
//   label: string;
//   orden: number;
//   campo: any;
//   espacio: number;
//   requerido: boolean;
//   tipo_campo: TipoControl;
//   sistema: boolean;
// }
export class ParametroFiltro {
  id?: number;
  label: string;
  alias?: string;
  orden: number;
  campo: any;
  espacio: number;
  requerido: boolean;
  tipo_campo: TipoControl;
  sistema: boolean;
  modal?: Modal;
  reporte?: number;
}

/**
 * Modelo base para cualquier modelo
 *
 * @export
 * @class ModeloBase
 */
export class ModeloBase {
  id: number;
  nombre: string;
  descripcion?: string;
}

export class Modal {
  id: number;
  nombre: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/global.model.ts